export function initStatsCountUp(): void {
  const statIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target as HTMLElement;
        const target = parseInt(el.dataset.target ?? "0", 10);
        const hasSuffix = el.querySelector(".suffix") !== null;
        const start = performance.now();
        const dur = 1400;

        function tick(now: number): void {
          const t = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - t, 3);
          const val = Math.floor(eased * target);
          el.textContent = String(val);
          if (hasSuffix) {
            const s = document.createElement("span");
            s.className = "suffix";
            s.textContent = "%";
            el.appendChild(s);
          }
          if (t < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
        statIO.unobserve(el);
      });
    },
    { threshold: 0.5 },
  );

  document
    .querySelectorAll<HTMLElement>(".stat-num")
    .forEach((el) => statIO.observe(el));
}
